import { Children, cloneElement, isValidElement } from "react";
import { FaSlidersH } from "react-icons/fa";
import { formatButtonLabel } from "../atlasButtonStyles";
import AtlasSearchInput from "./AtlasSearchInput";
import AtlasToolbarIconButton from "./AtlasToolbarIconButton";
import AtlasRefreshIconButton from "./AtlasRefreshIconButton";
import AtlasResultsMeta from "./AtlasResultsMeta";

export default function AtlasListToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  showSearch = true,
  showFilter = true,
  onFilterClick,
  filterOpen = false,
  onRefresh,
  refreshDisabled = false,
  refreshSpinning = false,
  extraControls = null,
  resultsMeta = null,
  showResultsMeta = true,
  actions = null,
  chipBar = null,
  className = "",
}) {
  const normalizeCreateLabels = (node) => {
    if (typeof node === "string") {
      return formatButtonLabel(node);
    }
    if (!isValidElement(node)) return node;

    const currentChildren = node.props?.children;
    const normalizedChildren =
      currentChildren !== undefined
        ? Children.map(currentChildren, (child) => normalizeCreateLabels(child))
        : currentChildren;

    const isNativeButton = node.type === "button";
    const extraProps = isNativeButton
      ? {
          className: [node.props.className, "uppercase"]
            .filter(Boolean)
            .join(" "),
        }
      : {};

    if (currentChildren !== undefined) {
      return cloneElement(node, extraProps, normalizedChildren);
    }
    return isNativeButton ? cloneElement(node, extraProps) : node;
  };

  const normalizedActions = actions ? normalizeCreateLabels(actions) : null;

  return (
    <div className={`mb-4 space-y-2 ${className}`}>
      <div className="flex w-full flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="flex min-w-0 flex-col gap-1 w-full md:w-auto">
          <div className="flex flex-row flex-wrap items-center gap-3">
            {showSearch ? (
              <AtlasSearchInput
                value={searchValue}
                onChange={onSearchChange}
                placeholder={searchPlaceholder}
              />
            ) : null}
            <div className="flex flex-wrap items-center gap-2">
              {extraControls}
              {showFilter && onFilterClick ? (
                <AtlasToolbarIconButton
                  onClick={onFilterClick}
                  title="Filter"
                  active={filterOpen}
                  aria-expanded={filterOpen}
                >
                  <FaSlidersH className="h-4 w-4" />
                </AtlasToolbarIconButton>
              ) : null}
              {onRefresh ? (
                <AtlasRefreshIconButton
                  onClick={onRefresh}
                  title="Refresh"
                  disabled={refreshDisabled}
                  spinning={refreshSpinning}
                />
              ) : null}
            </div>
          </div>
          {showResultsMeta && resultsMeta ? (
            <div className="min-w-0 max-w-full">
              <AtlasResultsMeta {...resultsMeta} />
            </div>
          ) : null}
        </div>
        {normalizedActions ? (
          <div className="flex shrink-0 flex-row flex-wrap items-center gap-2 w-full md:w-auto">
            {normalizedActions}
          </div>
        ) : null}
      </div>
      {chipBar}
    </div>
  );
}
